import {ReactNode} from 'react';

type Props = {
  children: ReactNode;
};

function MainContent(props: Props) {
  return (
    <main className="flex flex-col grow w-full max-w-[1600px] mx-auto pb-16 sm:pb-0 px-4 lg:px-36 lg:py-16">
      {props.children}
    </main>
  );
}

export {MainContent};
